import { useGetAccounts } from "@app/services/account";
import { useReassignToken } from "@app/services/reassign-token/hooks";
import { useAuthentication } from "@app/store/useAuthtentication";
import { saveUserNewRoleAndAccount } from "@app/utils/userDataToCookies";
import * as MC from "@mantine/core";
import { Header as HeaderView, UserAccount, UserAccountProfile } from "@ttn-shared/ui";
import { useMemo } from "react";
import { getEnvs } from "../utils/getEnvs";
import { useGenericData } from "@app/store/useGenericData";
import BiowelLogo from "@app/assets/logoBiowel.svg";
import { useDeliveryData } from "@app/store/useDeliverySearchData";

const { URL_PROTOCOL, URL_BASE, URL_SUB_DOMAIN_PAYROLL } = getEnvs();

export default function Header() {
  const userData = useAuthentication((state) => state.auth.dataBiowel);
  const clearAuthentication = useAuthentication((state) => state.clearAuthentication);

  const { data: accountsData } = useGetAccounts(userData?.idUser);

  const { clearGenericData } = useGenericData((state) => state);
  const { clearDataDispense } = useDeliveryData((state) => state);
  const { siteName, siteId } = useGenericData((store) => store.genericData);

  const { mutateAsync: reassignToken } = useReassignToken();

  const handleChangeAccount = async (account: UserAccount, profile: UserAccountProfile) => {
    const response = await reassignToken({ eaccount: account.id, profile: profile.id });

    if (!response.results?.token) {
      return;
    }

    saveUserNewRoleAndAccount({
      token: response.results.token,
      idAccount: account.id.toString(),
      idProfile: profile.id.toString()
    });

    window.location.href = `${URL_PROTOCOL}${URL_BASE}/categoryselect`;
  };

  const handleClickMyPayroll = () => {
    window.location.href = `${URL_PROTOCOL}${URL_SUB_DOMAIN_PAYROLL}${URL_BASE}/validate?myPayroll=1`;
  };

  const handleClickSettings = () => {
    window.location.href = `${URL_PROTOCOL}${URL_SUB_DOMAIN_PAYROLL}${URL_BASE}/validate?mySetting=1`;
  };

  const handleBackHome = () => {
    clearDataDispense();
    clearGenericData();

    window.location.href = `${URL_PROTOCOL}${URL_BASE}/categoryselect`;
  };

  const handleLogoutUser = () => {
    clearAuthentication();
    window.location.href = `${URL_PROTOCOL}${URL_BASE}/logout/${userData?.idUser}`;
  };

  const headerAccounts = useMemo<UserAccount[]>(() => {
    return (accountsData?.accounts ?? []).map((acc) => ({
      id: acc.id,
      name: acc.name,
      entityLogo: acc.entityLogo,
      profiles: acc.profile.map((prof) => ({
        id: prof.id,
        name: prof.nombre
      }))
    }));
  }, [accountsData]);

  return (
    <HeaderView
      moduleName="Dispensación"
      logo={<MC.Image src={BiowelLogo} alt="Biowel logo" w={150} />}
      accounts={headerAccounts}
      currentSite={!siteId ? undefined : { id: String(siteId), name: siteName }}
      onChangeAccount={(account, profile) => void handleChangeAccount(account, profile)}
      onClickMyPayroll={handleClickMyPayroll}
      onClickSettings={handleClickSettings}
      onBackHome={handleBackHome}
      onLogout={handleLogoutUser}
    />
  );
}
